import React, {memo, useEffect, useState} from "react"
import $ from "jquery";
import {RecoilRoot} from "recoil";
import {render} from "react-dom";
import {useConnectedValue, useExternalAtom} from "../js/state-hooks";
import {as_memory, MemoItem, toggleMemoList} from "../js/app";
import {openPopup} from "../js-app/util/state-util";
import {as_memoSettings} from "../js-backend/state";
import {getActivitiyData} from "../js-memo/state";


interface IMenuButtonProps{

}
const MemoMenuButton:React.FC<IMenuButtonProps> = () => {
	const memoData = useConnectedValue(as_memoSettings);
	const [asMemo,setAsMemo] = useExternalAtom<MemoItem[]>(as_memory);
	const [showOverlay,setShowOverlay] = useState<false|string>(false);
	const [hintPos,setHintPos] = useState<{[key:string]:string}>({});
	useEffect(()=>{
		const calcHintPos = ()=>{
			var r = $el[0].getBoundingClientRect();
			var cx = 100 * (r.left + r.width/2) / window.innerWidth;
			var cy = 100 * r.bottom / window.innerHeight;
			setHintPos({top:cy+'%', left:cx+'%'})
		}
		window.addEventListener('resize',calcHintPos)
		calcHintPos();
	},[showOverlay]);
	useEffect(()=>{
		if(initalMemoCount == 0 && asMemo.length > 0){
			setShowOverlay(getActivitiyData(asMemo[0]).name);
			initalMemoCount = -1; //show only once
		}
	},[asMemo]);
	//calculate where the hint should be shown.
	
	var customStyles = '';
	for (let memoDataKey in memoData) {
		if(memoDataKey.indexOf('mmb-') != -1)
			customStyles += `--${memoDataKey}:${memoData[memoDataKey]}; `;
	}
	
	return (<div className={`__neostyles memo-menu-button ${asMemo.length <= 0 ? '' : 'active'}`}>
		{customStyles && <style> {`:root{ ${customStyles} } ${memoData.customMMBCss || ''}`} </style>}
		
		<a className="btn-text fl-row" onClick={(e)=>toggleMemoList(e)}>
			Merkzettel
			{asMemo.length > 0 &&
				<>
				<span className={'separator'}/>{asMemo.length}
				</>
			}
		</a>
		{showOverlay &&
			<div className="hint-wrapper" >
				<div className={'hint'}>
                    <svg width="29px" height="12px" viewBox="0 0 29 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <polyline id="cart-hint-arrow" strokeWidth="4" transform="translate(14.500000, 5.950000) rotate(-540.000000) translate(-14.500000, -5.950000) " points="27.45 2.45 14.5 9.45 1.55 2.45"></polyline>
                        </g>
                    </svg>
					Hier findest du<br/>deinen Merkzettel
				</div>
			</div>
		}
		{showOverlay &&
			<div className={'overlay'} >
				<div className="memo-popup pad-75">
					<div className="title margin-50-bottom">{memoData.mmbPopupTitle}</div>
					<p>{memoData.mmbPopupText}</p>
					<a className="margin-75-top" onClick={()=>{
						setShowOverlay(false);
						openPopup(true);
					}}>
						Anfrage für {showOverlay} starten
					</a>
					<button className={'margin-25-top'} onClick={()=>setShowOverlay(false)}>
						Weiter stöbern
					</button>
				</div>
			</div>
		}
	</div>);
};

var $el = $('.neorp-menu-memo-btn');
var initalMemoCount = as_memory.get().length;
if($el.length > 0){
	$el.remove('a');
	render(<RecoilRoot><MemoMenuButton/></RecoilRoot>, $el[0])
}